import type { Theme } from '@material-ui/core';
import { darken } from '@material-ui/core';
import { createStyles } from '@material-ui/core';

const styles = (theme: Theme) => {
  const { main, contrastText } = theme.palette.primary;

  return createStyles({
    navButton: {
      display: 'flex',
      padding: '0.357rem 1.4rem',
      cursor: 'pointer',
      userSelect: 'none',

      '@media (max-width: 991px)': {
        background: main,
        '&:hover': {
          backgroundColor: darken(main, 0.3),
          color: contrastText
        },

        '&:nth-child(1)': {
          '-ms-grid-row': 1
        },
        '&:nth-child(2)': {
          '-ms-grid-row': 2
        },
        '&:nth-child(3)': {
          '-ms-grid-row': 3
        },
        '&:nth-child(4)': {
          '-ms-grid-row': 4
        },
        '&:nth-child(5)': {
          '-ms-grid-row': 5
        },
        '&:nth-child(6)': {
          '-ms-grid-row': 6
        }
      },

      '@media (min-width: 992px)': {
        padding: '0.21rem 0.357rem',
        height: '100%',

        '&:nth-child(1)': {
          '-ms-grid-column': 1
        },
        '&:nth-child(2)': {
          '-ms-grid-column': 2
        },
        '&:nth-child(3)': {
          '-ms-grid-column': 3
        },
        '&:nth-child(4)': {
          '-ms-grid-column': 4
        },
        '&:nth-child(5)': {
          '-ms-grid-column': 5
        },
        '&:nth-child(6)': {
          '-ms-grid-column': 6
        }
      }
    },

    navButtonText: {
      MsGridColumnAlign: 'center',
      alignSelf: 'center',
      justifySelf: ' center',
      fontSize: '13px',
      color: '#FFFFFF',
      borderRadius: '5px',
      padding: '5px 8px ',

      '@media (min-width: 992px)': {
        color: theme.navText || '#1C2541',

        '&:hover': {
          backgroundColor: main,
          color: contrastText
        }
      }
    }
  });
};

export default styles;
